/**
 * Ring Sizer Tool — performetic
 *
 * Kalibrasyon: pixelsToMmRatio = kartYukseklikPx / 54 (kredi karti yuksekligi)
 * Daire: scale transform → render edilen yukseklik / pixelsToMmRatio = capMm
 * Ip: scale transform → render edilen yukseklik / pixelsToMmRatio = cevreMm
 */

(function () {
  'use strict';

  /* =========================================================
     Boyut tablosu — cap (mm) ve no (beden) eslesmesi
     ========================================================= */
  var BOYUT_TABLOSU = [
    { cap: 14.7, no: '6'  },
    { cap: 15.0, no: '7'  },
    { cap: 15.3, no: '8'  },
    { cap: 15.6, no: '9'  },
    { cap: 15.9, no: '10' },
    { cap: 16.2, no: '11' },
    { cap: 16.5, no: '12' },
    { cap: 16.8, no: '13' },
    { cap: 17.2, no: '14' },
    { cap: 17.5, no: '15' },
    { cap: 17.8, no: '16' },
    { cap: 18.1, no: '17' },
    { cap: 18.4, no: '18' },
    { cap: 18.8, no: '19' },
    { cap: 19.1, no: '20' },
    { cap: 19.4, no: '21' },
    { cap: 19.7, no: '22' },
    { cap: 20.0, no: '23' },
    { cap: 20.3, no: '24' },
    { cap: 20.6, no: '25' },
    { cap: 21.0, no: '26' },
    { cap: 21.3, no: '27' },
    { cap: 21.6, no: '28' },
    { cap: 22.0, no: '29' },
    { cap: 22.3, no: '30' },
    { cap: 22.6, no: '31' }
  ];

  /* =========================================================
     cap (mm) degerinden boyut bul
     diameter >= satir mm ise o satiri al (en buyuk eslesen)
     ========================================================= */
  function getRingSizeFromDiameter(diameterMm) {
    var firstKey = BOYUT_TABLOSU[0].cap;
    var result = null;
    for (var i = 0; i < BOYUT_TABLOSU.length; i++) {
      if (parseFloat(diameterMm) >= parseFloat(BOYUT_TABLOSU[i].cap)) {
        result = BOYUT_TABLOSU[i];
      }
    }
    return result || BOYUT_TABLOSU[0];
  }

  /* cevre (mm) degerinden boyut bul */
  function getRingSizeFromCircumference(circumferenceMm) {
    return getRingSizeFromDiameter((circumferenceMm / Math.PI).toFixed(2));
  }

  /* Sinir kontrolu */
  function getBoundaryStatus(diameterMm) {
    var d = parseFloat(diameterMm);
    if (d <= BOYUT_TABLOSU[0].cap) return 'below';
    if (d >= BOYUT_TABLOSU[BOYUT_TABLOSU.length - 1].cap) return 'above';
    return 'in_range';
  }

  /* =========================================================
     Mobil cihaz algilama
     ========================================================= */
  function isMobile() {
    var ua = navigator.userAgent || navigator.vendor || '';
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua)) return true;
    if ('ontouchstart' in window || navigator.maxTouchPoints > 0) {
      if (window.innerWidth <= 1024) return true;
    }
    if (/Mobi|Mobile/i.test(ua)) return true;
    return false;
  }

  /* =========================================================
     Zoom kontrolu
     ========================================================= */
  function isZoomed() {
    return window.visualViewport && window.visualViewport.scale !== 1;
  }

  /* =========================================================
     QR Code olusturma
     ========================================================= */
  function generateQRCode(container, url) {
    function renderQR() {
      try {
        new QRCode(container, { text: url, width: 200, height: 200, colorDark: '#1a1a2e', colorLight: '#ffffff' });
      } catch (e) { renderFallback(); }
    }
    function renderFallback() {
      container.innerHTML = '<div style="padding:2rem;text-align:center;border:1px solid #ddd;border-radius:8px;">' +
        '<p style="margin:0 0 0.5rem;font-weight:600;">QR Kod</p>' +
        '<p style="margin:0;font-size:0.75rem;word-break:break-all;">' + url + '</p></div>';
    }
    if (typeof QRCode !== 'undefined') { renderQR(); }
    else {
      var script = document.createElement('script');
      script.src = 'https://cdn.jsdelivr.net/npm/qrcodejs@1.0.0/qrcode.min.js';
      script.onload = function () { renderQR(); };
      script.onerror = function () { renderFallback(); };
      document.head.appendChild(script);
    }
  }

  /* =========================================================
     Ana uygulama
     ========================================================= */
  function RingSizer(container) {
    if (!container) return;
    this.container = container;
    this.currentStep = null;
    this.method = null;

    /* performetic: varsayilan deger */
    this.pixelsToMmRatio = 6.54;

    /* localStorage'dan onceki kalibrasyon */
    try {
      var stored = window.localStorage.getItem('pixelsToMmRatio');
      if (stored) this.pixelsToMmRatio = parseFloat(stored);
    } catch (e) { /* ignore */ }

    this.steps = {};
    this.elements = {};

    /* Daire ve ip icin translate/scale degerleri */
    this.ringTranslateX = 0;
    this.ringTranslateY = 0;

    this.init();
  }

  /* =========================================================
     INIT
     ========================================================= */
  RingSizer.prototype.init = function () {
    this.cacheElements();

    /* performetic: Tema editorunde onizleme modu */
    if (window.Shopify && window.Shopify.designMode) {
      var previewStep = this.container.getAttribute('data-preview-step') || 'step1';
      this.showStep(previewStep);
      this.bindEvents();
      this.listenEditorChanges();
      this.container.classList.add('is-initialized');
      return;
    }

    if (!isMobile()) {
      this.showDesktop();
      this.container.classList.add('is-initialized');
      return;
    }

    this.checkZoom();
    this.bindEvents();
    this.showStep('step1');
    this.container.classList.add('is-initialized');
  };

  RingSizer.prototype.cacheElements = function () {
    var c = this.container;
    this.steps = {
      desktop: c.querySelector('[data-step="desktop"]'),
      step1: c.querySelector('[data-step="step1"]'),
      step2: c.querySelector('[data-step="step2"]'),
      step3: c.querySelector('[data-step="step3"]'),
      step4a: c.querySelector('[data-step="step4a"]'),
      step4b: c.querySelector('[data-step="step4b"]'),
      result: c.querySelector('[data-step="result"]')
    };
    this.elements = {
      card: c.querySelector('[data-card]'),
      cardSlider: c.querySelector('[data-slider="card"]'),
      circle: c.querySelector('[data-circle]'),
      circleSlider: c.querySelector('[data-slider="circle"]'),
      circleSizeDisplay: c.querySelector('[data-circle-size]'),
      circleMmDisplay: c.querySelector('[data-circle-mm]'),
      stringLine: c.querySelector('[data-string-line]'),
      stringSlider: c.querySelector('[data-slider="string"]'),
      stringSizeDisplay: c.querySelector('[data-string-size]'),
      stringMmDisplay: c.querySelector('[data-string-mm]'),
      resultSize: c.querySelector('[data-result-size]'),
      resultMm: c.querySelector('[data-result-mm]'),
      zoomWarning: c.querySelector('[data-zoom-warning]'),
      qrContainer: c.querySelector('[data-qr]')
    };
  };

  /* performetic: Tema editorunde ayar degistiginde adimi guncelle */
  RingSizer.prototype.listenEditorChanges = function () {
    var self = this;
    var observer = new MutationObserver(function () {
      var newStep = self.container.getAttribute('data-preview-step');
      if (newStep && newStep !== self.currentStep) self.showStep(newStep);
    });
    observer.observe(self.container, { attributes: true, attributeFilter: ['data-preview-step'] });
  };

  /* =========================================================
     EVENT BINDING
     ========================================================= */
  RingSizer.prototype.bindEvents = function () {
    var self = this;
    var c = this.container;

    /* Buton click olaylari */
    c.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-action]');
      if (!btn) return;
      var action = btn.getAttribute('data-action');

      switch (action) {
        case 'next-step1': self.showStep('step2'); break;
        case 'next-step2': self.calibrate(); self.showStep('step3'); break;
        case 'method-ring': self.method = 'circle'; self.showStep('step4a'); break;
        case 'method-string': self.method = 'string'; self.showStep('step4b'); break;
        case 'select-circle': self.showResult(); break;
        case 'select-string': self.showResult(); break;
        case 'back-step1': self.showStep('step1'); break;
        case 'back-step2': self.showStep('step2'); break;
        case 'back-step3': self.showStep('step3'); break;
        case 'back-step4':
          if (self.method === 'circle') self.showStep('step4a');
          else self.showStep('step4b');
          break;
        case 'close': self.showStep('step3'); break;
        case 'result-back': self.showStep('step3'); break;
        case 'result-shop':
          window.location.href = c.getAttribute('data-shop-url') || '/collections/all';
          break;
        case 'result-visit':
          window.location.href = c.getAttribute('data-site-url') || '/';
          break;
        /* Daire yon oklari translate degistirir */
        case 'arrow-up': self.ringTranslateY--; self.applyRingTransform(); break;
        case 'arrow-down': self.ringTranslateY++; self.applyRingTransform(); break;
        case 'arrow-left': self.ringTranslateX--; self.applyRingTransform(); break;
        case 'arrow-right': self.ringTranslateX++; self.applyRingTransform(); break;
      }
    });

    /* Slider +/- butonlari */
    c.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-slider-btn]');
      if (!btn) return;
      var target = btn.getAttribute('data-slider-btn');
      var dir = btn.getAttribute('data-dir');
      var slider = c.querySelector('[data-slider="' + target + '"]');
      if (!slider) return;
      var step = parseFloat(slider.step) || 1;
      var val = parseFloat(slider.value);
      var newVal = dir === 'plus' ? val + step : val - step;
      newVal = Math.max(parseFloat(slider.min), Math.min(parseFloat(slider.max), newVal));
      slider.value = newVal;
      slider.dispatchEvent(new Event('input'));
    });

    /* Kalibrasyon slider */
    if (this.elements.cardSlider) {
      this.elements.cardSlider.addEventListener('input', function () {
        self.updateCard();
      });
    }

    /* Daire slider */
    if (this.elements.circleSlider) {
      this.elements.circleSlider.addEventListener('input', function () {
        self.updateCircle();
      });
    }

    /* Ip slider */
    if (this.elements.stringSlider) {
      this.elements.stringSlider.addEventListener('input', function () {
        self.updateString();
      });
    }
  };

  /* =========================================================
     Adim gecisleri
     ========================================================= */
  RingSizer.prototype.showStep = function (stepName) {
    for (var key in this.steps) {
      if (this.steps[key]) this.steps[key].classList.remove('is-active');
    }
    if (this.steps[stepName]) {
      this.steps[stepName].classList.add('is-active');
      this.currentStep = stepName;
    }
    /* step2 acildiginda kart slider'i baslat */
    if (stepName === 'step2' && this.elements.cardSlider) {
      this.updateCard();
    }
    /* step4a acildiginda ring slider'i baslat */
    if (stepName === 'step4a' && this.elements.circleSlider) {
      this.ringTranslateX = 0;
      this.ringTranslateY = 0;
      this.updateCircle();
    }
    /* step4b acildiginda string slider'i baslat */
    if (stepName === 'step4b' && this.elements.stringSlider) {
      this.updateString();
    }
  };

  RingSizer.prototype.showDesktop = function () {
    for (var key in this.steps) {
      if (this.steps[key]) this.steps[key].classList.remove('is-active');
    }
    if (this.steps.desktop) {
      this.steps.desktop.classList.add('is-active');
      if (this.elements.qrContainer) {
        generateQRCode(this.elements.qrContainer, window.location.href);
      }
    }
  };

  RingSizer.prototype.checkZoom = function () {
    if (this.elements.zoomWarning && isZoomed()) {
      this.elements.zoomWarning.classList.add('is-visible');
    }
  };

  /* =========================================================
     ADIM 2: KALIBRASYON
     
     - Kart sabit boyut, scale transform ile buyutulup kucultulur
     - Slider 0-100, scale = (value/100) * 1.2 + 0.6
     - pixelsToMmRatio = kart render edilen yukseklik / 54 (mm)
     ========================================================= */
  RingSizer.prototype.updateCard = function () {
    if (!this.elements.card || !this.elements.cardSlider) return;

    var sliderVal = parseFloat(this.elements.cardSlider.value);
    var ratio = sliderVal / 100;

    /* scale = value * 1.2 + 0.6  (0.6 — 1.8)
       right = -320 + 240 * -value  (-320 — -560)  */
    var scale = ratio * 1.2 + 0.6;
    var posRight = -320 + 240 * -ratio;

    this.elements.card.style.transform = 'scale(' + scale + ')';
    this.elements.card.style.right = posRight + 'px';

    /* Kalibrasyon hesapla: pixelsToMmRatio = kart render yukseklik / 54mm */
    var rect = this.elements.card.getBoundingClientRect();
    var cardHeight = rect.bottom - rect.top;
    if (cardHeight > 0) {
      this.pixelsToMmRatio = cardHeight / 54;
    }
  };

  RingSizer.prototype.calibrate = function () {
    /* pixelsToMmRatio zaten updateCard'da hesaplandi, localStorage'a kaydet */
    try {
      window.localStorage.setItem('pixelsToMmRatio', this.pixelsToMmRatio.toString());
    } catch (e) { /* ignore */ }
  };

  /* =========================================================
     ADIM 4a: DAIRE OLCUM
     
     - Daire sabit boyut (116x116px), scale transform ile buyutulup kucultulur
     - Slider 0-100, scale = (value/100) * (1.8 - 0.6) + 0.6
     - capMm = render edilen daire yukseklik / pixelsToMmRatio
     - Yon oklari translate(x,y) ile daireyi hareket ettirir
     ========================================================= */
  RingSizer.prototype.updateCircle = function () {
    if (!this.elements.circle || !this.elements.circleSlider) return;

    var sliderVal = parseFloat(this.elements.circleSlider.value);
    var ratio = sliderVal / 100;
    var scale = ratio * (1.8 - 0.6) + 0.6;

    this.elements.circle.style.transform =
      'translate(' + this.ringTranslateX + 'px, ' + this.ringTranslateY + 'px) scale(' + scale + ')';

    /* Render edilen boyutu al */
    var rect = this.elements.circle.getBoundingClientRect();
    var renderHeight = rect.bottom - rect.top;
    var diameterMm = (renderHeight / this.pixelsToMmRatio).toFixed(2);

    /* mm goster */
    if (this.elements.circleMmDisplay) {
      this.elements.circleMmDisplay.textContent = diameterMm + 'mm';
    }

    /* Boyut hesapla ve goster */
    var size = getRingSizeFromDiameter(diameterMm);
    this.updateSizeDisplay(parseFloat(diameterMm), size, 'circle');

    /* Sonuc icin sakla */
    this._lastDiameter = parseFloat(diameterMm);
    this._lastSize = size;
  };

  RingSizer.prototype.applyRingTransform = function () {
    if (!this.elements.circle) return;
    /* Mevcut scale degerini koru */
    var rect = this.elements.circle.getBoundingClientRect();
    var scale = rect.width / this.elements.circle.offsetWidth;
    this.elements.circle.style.transform =
      'translate(' + this.ringTranslateX + 'px, ' + this.ringTranslateY + 'px) scale(' + scale + ')';
  };

  /* =========================================================
     ADIM 4b: IP OLCUM
     
     - Cizgi sabit boyut (400px height), scale transform ile buyutulup kucultulur
     - Slider 5-50, scale = (value/100) * (1.8 - 0.6) + 0.6
     - cevreMm = render edilen cizgi yukseklik / pixelsToMmRatio
     - capMm = cevreMm / PI
     ========================================================= */
  RingSizer.prototype.updateString = function () {
    if (!this.elements.stringLine || !this.elements.stringSlider) return;

    var sliderVal = parseFloat(this.elements.stringSlider.value);
    var ratio = sliderVal / 100;
    var scale = ratio * (1.8 - 0.6) + 0.6;

    this.elements.stringLine.style.transform = 'scale(' + scale + ')';

    /* Render edilen boyutu al */
    var rect = this.elements.stringLine.getBoundingClientRect();
    var renderHeight = rect.bottom - rect.top;
    var circumferenceMm = (renderHeight / this.pixelsToMmRatio).toFixed(2);

    /* mm goster */
    if (this.elements.stringMmDisplay) {
      this.elements.stringMmDisplay.textContent = circumferenceMm + 'mm';
    }

    /* Boyut hesapla ve goster */
    var size = getRingSizeFromCircumference(circumferenceMm);
    var diameterMm = parseFloat((circumferenceMm / Math.PI).toFixed(2));
    this.updateSizeDisplay(diameterMm, size, 'string');

    /* Sonuc icin sakla */
    this._lastDiameter = diameterMm;
    this._lastSize = size;
  };

  /* =========================================================
     Boyut gosterimi
     ========================================================= */
  RingSizer.prototype.updateSizeDisplay = function (diameterMm, size, method) {
    var displayEl = method === 'circle'
      ? this.elements.circleSizeDisplay
      : this.elements.stringSizeDisplay;

    if (!displayEl) return;

    var sizeLabel = displayEl.getAttribute('data-label') || 'Yüzük Ölçünüz';
    var smallerText = displayEl.getAttribute('data-smaller') || 'ölçüsünden daha küçük';
    var largerText = displayEl.getAttribute('data-larger') || 'ölçüsünden daha büyük';

    var boundary = getBoundaryStatus(diameterMm);

    if (boundary === 'below') {
      displayEl.innerHTML = '<strong>' + sizeLabel + ':</strong> ' +
        size.no + ' ' + smallerText;
    } else if (boundary === 'above') {
      displayEl.innerHTML = '<strong>' + sizeLabel + ':</strong> ' +
        size.no + ' ' + largerText;
    } else {
      displayEl.innerHTML = '<strong>' + sizeLabel + ': ' + size.no + '</strong>';
    }

    /* Sonuc ekraninda goster icin sakla */
    try {
      window.localStorage.setItem('ringsize', parseInt(size.no));
    } catch (e) { /* ignore */ }
  };

  /* =========================================================
     SONUC EKRANI
     ========================================================= */
  RingSizer.prototype.showResult = function () {
    this.showStep('result');

    if (!this._lastSize) return;

    var size = this._lastSize;
    var diameterMm = this._lastDiameter;

    if (this.elements.resultSize) {
      var headingLabel = this.elements.resultSize.getAttribute('data-heading') || 'Yüzük Ölçünüz';
      this.elements.resultSize.textContent = headingLabel + ': ' + size.no;
    }

    if (this.elements.resultMm) {
      this.elements.resultMm.textContent = diameterMm.toFixed(1) + ' mm';
    }

    /* pixelsToMmRatio kaydet */
    try {
      window.localStorage.setItem('pixelsToMmRatio', this.pixelsToMmRatio.toString());
    } catch (e) { /* ignore */ }
  };

  /* =========================================================
     Baslat
     ========================================================= */
  function initAllRingSizers() {
    var containers = document.querySelectorAll('[data-ring-sizer]');
    for (var i = 0; i < containers.length; i++) {
      if (!containers[i]._ringSizerInit) {
        containers[i]._ringSizerInit = true;
        new RingSizer(containers[i]);
      }
    }
  }

  document.addEventListener('DOMContentLoaded', initAllRingSizers);

  /* performetic: Tema editorunde section yeniden yuklendiginde tekrar baslat */
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector('[data-ring-sizer]')) {
      var container = e.target.querySelector('[data-ring-sizer]');
      container._ringSizerInit = true;
      new RingSizer(container);
    }
  });
})();
